<h2 mat-dialog-title>Kritikus pontok ellenőrzése</h2>

<mat-dialog-content class="dialog-content">
  <div class="meta-row">
    <span>Workflow: {{ data.workflowId }}</span>
    <span>Ellenőrzött pontok: {{ data.checks.length }}</span>
  </div>

  <div class="meta-row">
    <span>Útvonal: {{ data.practicePathUuid }}</span>
  </div>

  <div class="meta-row">
    <span class="success-count">Megfelelő: {{ successfulChecksCount }}</span>
    <span class="failed-count">Hibás: {{ failedChecks.length }}</span>
  </div>

  <div *ngIf="failedChecks.length === 0" class="all-ok-state">
    Minden kritikus pont megfelelt az ellenőrzésen.
  </div>

  <div *ngIf="failedChecks.length > 0" class="failed-items-container">
    <div class="failed-item" *ngFor="let failedCheck of failedChecks">
      <div class="failed-item-header">
        <span class="failed-item-title">{{ failedCheck.criticalPointTitle }}</span>
        <span class="failed-item-uuid">{{ failedCheck.criticalPointUuid }}</span>
      </div>
      <div class="failed-item-reason">
        {{ failedCheck.reason || "Nincs részletes indoklás." }}
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Bezárás</button>
</mat-dialog-actions>
